/* TODO: t() */
import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';

import formatDate from '../../core/support/formatDate';
import { DataTable } from '../uiold';

import {
  FormSubmissionByDate,
  FormSubmission,
} from '../../types/shared/FormSubmission';

type Props = {
  submissionsByDate: FormSubmissionByDate;
  setSelectedSubmission: (s: FormSubmission) => void;
};

function SubmissionList(props: Props) {
  let { submissionsByDate, setSelectedSubmission } = props;

  return (
    <View style={styles.root}>
      <Header />
      <ScrollView>
        {Object.entries(submissionsByDate).map(([date, submission]) => {
          return (
            <SubmissionListItem
              key={date}
              submission={submission}
              date={date}
              onPress={() => setSelectedSubmission(submission)}
            />
          );
        })}
      </ScrollView>
    </View>
  );
}

function Header() {
  return (
    <View style={styles.header}>
      <DataTable.HeaderCell>MARKET DATE</DataTable.HeaderCell>
      <DataTable.HeaderCell>CREATED AT</DataTable.HeaderCell>
    </View>
  );
}

type ItemProps = {
  submission: FormSubmission;
  date: string;
  onPress: () => void;
};

function SubmissionListItem(props: ItemProps) {
  let { submission, date, onPress } = props;

  return (
    <DataTable.Row onPress={onPress}>
      <DataTable.Cell>
        {formatDate(date, { fromUTC: true, includeDayOfWeek: true })}
      </DataTable.Cell>
      <DataTable.Cell>
        {submission.created_at
          ? formatDate(submission.created_at, { includeDayOfWeek: true })
          : ''}
      </DataTable.Cell>
    </DataTable.Row>
  );
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    paddingHorizontal: 20,
    paddingVertical: 5,
  },
});

export default SubmissionList;
